<template>
  <svg data-icon-name="apple" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.047 34"><path d="M15.35 3.388A6.954 6.954 0 0 1 20.506.5a7.114 7.114 0 0 1-1.753 5.259A5.438 5.438 0 0 1 13.8 8.028s-.409-2.062 1.55-4.64zm-1.134 6.6c1.134 0 3.2-1.547 5.878-1.547a7.452 7.452 0 0 1 6.5 3.3 7.247 7.247 0 0 0-3.609 6.291 7.39 7.39 0 0 0 4.434 6.7S24.322 33.5 20.094 33.5c-1.959 0-3.4-1.341-5.466-1.341S10.5 33.5 9.162 33.5C5.347 33.5.5 25.25.5 18.547c0-6.6 4.125-10 7.941-10 2.475 0 4.434 1.444 5.775 1.444z" fill="none" stroke="#000" stroke-miterlimit="10"/></svg>
</template>

<script>
import {
  defineComponent,
} from 'vue';

export default defineComponent({});
</script>
